import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AgentDashboard.css";

const AgentDashboard = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const storedRole = localStorage.getItem("role");

    if (!storedUser || storedRole !== "agent") {
      navigate("/login");
      return;
    }

    setUsername(storedUser.username || "Agent");
    setRole(storedRole);
  }, [navigate]);

  return (
    <div className="agent-container">
      <h2 className="agent-title">Agent Dashboard</h2>

      <div className="agent-info">
        <p>
          👤 <strong>Agent:</strong> {username}
        </p>
        <p>
          🛡 
        </p>
      </div>

      <div className="agent-grid">
        {/* ADD MATCH */}
        <div
          className="agent-card"
          onClick={() => navigate("/agent-add-matches")}
        >
          <h3>➕ Add Match</h3>
          <p>Ongeza mechi mpya (Andiki matches kwa usahii)</p>
        </div>

        {/* PENDING MATCHES */}
        <div
          className="agent-card"
          onClick={() => navigate("/agent-pending")}
        >
          <h3>⏳ Pending</h3>
          <p>Withdraw zinazosubiri approval</p>
        </div>

        {/* SEARCH USER */}
        <div
          className="agent-card"
          onClick={() => navigate("/agent-search-user")}
        >
          <h3>🔍 Search User</h3>
          <p>Tafuta taarifa za mtumiaji</p>
        </div>

        {/* VIEW MATCHES */}
        <div
          className="agent-card"
          onClick={() => navigate("/matchlist")}
        >
          <h3>⚽ Matches</h3>
          <p>Angalia mechi zote</p>
        </div>


        <div
          className="agent-card"
          onClick={() => navigate("/agent-historiayadau")}
        >
          <h3>Historiayadau</h3>
          <p>📜 Kagua Miamala ya watumiaji</p>
        </div>

      
        <div
          className="agent-card"
          onClick={() => navigate("/agent-DuplicateMatches")}
        >
          <h3>Futa matches</h3>
          <p>Futa matches zilizo jirudia</p>
        </div>


        {/* LOGOUT */}
        <div
          className="agent-card danger"
          onClick={() => {
            localStorage.clear();
            navigate("/login");
          }}
        >


          <h3>🚪 Logout</h3>
          <p>Toka kwenye akaunti</p>
        </div>
      </div>
    </div>
  );
};

export default AgentDashboard;